import { Outlet, ScrollRestoration } from 'react-router';
import { StagingRibbon } from '@/components/StagingRibbon';

/**
 * Every navigation starts at the top of the new page (Back restores the old
 * position) with an instant jump — never an animated or forced scroll.
 */
export function RootRoute() {
  return (
    <>
      <ScrollRestoration />
      <Outlet />
      <StagingRibbon />
    </>
  );
}
